module.exports = __webpack_public_path__ + "static/media/image06.773dfaad.jpg";